export default __webpack_public_path__ + "static/media/sidebar_accessories_gray.0f7250f5.svg";